import * as R from 'ramda';
import {Taggable} from '../../interfaces/taggable';

export const getTags = (taggable: Taggable) => R.pathOr([], ['attributes', 'tags'], taggable);
